import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Grid2,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function DeleteSessionModal({
  open,
  onClose,
  onConfirm,
  sessionDescription,
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: "500px",
          bgcolor: "background.paper",
          border: "1px solid #ccc",
          borderRadius: "8px",
          boxShadow: 24,
          p: 4,
          direction: "rtl",
        }}
      >
        {/* Modal Header */}
        <Grid2
          container
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Typography id="delete-session-modal" variant="h6">
            حذف تمرین {sessionDescription}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Grid2>
        <Typography variant="body1" sx={{ mb: 3 }}>
          آیا از حذف این تمرین مطمئن هستید؟
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 3,
          }}
        >
          <Button variant="outlined" onClick={onClose}>
            انصراف
          </Button>
          <Button variant="contained" color="error" onClick={onConfirm}>
            حذف
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
